import { QueryClient, QueryKey } from "@tanstack/react-query";

async function optimisticallyUpdateQueryData<TDto>(
  queryClient: QueryClient,
  queryKey: QueryKey,
  update: (cachedData: TDto) => Partial<TDto>
) {
  await queryClient.cancelQueries(queryKey);
  const cachedData = queryClient.getQueryData<TDto>(queryKey);

  if (cachedData) {
    const updatedData: TDto = {
      ...cachedData,
      ...update(cachedData),
    };

    queryClient.setQueryData(queryKey, updatedData);
  }

  return cachedData;
}

export { optimisticallyUpdateQueryData };
